var map; // Create a global variable for the map. 
var markers = [];  // Create a global variable for the markers.
let infowindow; // Create a global variable for infowindow.
let styledMap; // Create a global variable for styledMap.

// Load the map on the page, center and set zoom level. 
function initGoogleMap() {
    const styles = [];
      
    // Create a new StyledMapType object, passing it the array of styles,
    // as well as the name to be displayed on the map type control.
    if ( typeof mapName === 'undefined' ) {
        console.warn('[mapName] variable not exists, please specify in each page')
    } else {
        styledMap = new google.maps.StyledMapType(styles, {name: mapName});
    }
        
    map = new google.maps.Map(document.getElementById('map_canvas'), {
        zoom: 13,
        center: new google.maps.LatLng(placeLatLng.lat, placeLatLng.lng),
        mapTypeControlOptions: {
            mapTypeIds: [google.maps.MapTypeId.HYBRID, 'map_style']
        }
    });


    // Add the markers from the marker array.    
    function addMarker(feature) {
        var marker = new google.maps.Marker({
            position: feature.position,
            icon: features[i].icon,
            title: features[i].name,
            map: map
        });
        markers.push({
            marker: marker,
            type: feature.type
        });
        google.maps.event.addListener(marker, 'click', function () {
            if (typeof infowindow != 'undefined') infowindow.close();
            infowindow = new google.maps.InfoWindow({
                content: feature.name
            });
            infowindow.open(map, marker);
        });
        // This section will close any open info windows when you click anywhere on the map. 
        google.maps.event.addListener(map, 'click', function () {
            infowindow.close();
        });
    }

    if ( typeof placeLatLng === 'undefined' ) {
        console.warn('[placeLatLng] variable not exists, please specify in each page')
    } else if ( typeof placeIcon === 'undefined' ) {
        console.warn('[placeIcon] variable not exists, please specify in each page')
    } else {
        // Map Maker Logo
        const logo = new google.maps.Marker({
            position: new google.maps.LatLng(placeLatLng.lat, placeLatLng.lng),
            map: map,
            zIndex: 999,
            icon: placeIcon,
            title: mapName
        });
    }


    //Associate the styled map with the MapTypeId and set it to display.
    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');

    // Create a "set" of filter types.    
    var icons = {
        education: {
            name: 'Education',
            category: 'education'
        },
        transport: {
            name: 'Transport',
            category: 'transport'
        },
        // flight: {
        //     name: 'Flight',
        //     category: 'flight'
        // },
        foodShopping: {
            name: 'Food & Shopping',
            category: 'food-shopping'
        },
        parksHospitalsLandmarks: {
            name: 'Parks, Hospitals & Landmarks',
            category: 'parks-hospitals-landmarks'
        },
        commercialareaOfficesBuilding: {
            name: 'Commercial Area, Offices & Building',
            category: 'commercialarea-offices-building'
        }
    };

    // Itterate through the markers and add them to the map.
    if ( typeof features === 'undefined' ) {
        console.warn('[features] variable not exists, please specify in each page')
    } else {
        for (var i = 0, feature; feature = features[i]; i++) {
            addMarker(feature);
        }
    }

    // This section creates the filter box. 
    const legend = document.getElementById('legend');
    const legendUl = document.querySelector('.legend-filter');
    var i = 0;
    for (var key in icons) {
        var type = icons[key];
        var name = type.name;
        var category = type.category;
        var li = document.createElement('li');

        features.forEach( feature => {
            if (feature.type == category) {
                li.innerHTML = `
                <input checked="checked" type="checkbox" id="box-${category}" data-type="${category}"> 
                <label for="box-${category}">${name}</label>
                `
                li.classList.add('d-flex')
            }
        })


        legendUl.appendChild(li);
        i++;
    }

    // Filter markers. 
    const allInput = legend.querySelectorAll('div input');
    allInput.forEach( el => {
        const elType = el.dataset.type;
        el.addEventListener('change', function(event) {
            console.log(elType);
            var on = el.checked;
            for (var i = 0; i < markers.length; i++) {
                if (markers[i].type == elType) {
                    markers[i].marker.setMap(on ? map : null);
                }
            }
        })
    })

}


export default initGoogleMap;
